import { ChangeDetectionStrategy, Component } from '@angular/core'
import {
  StatusContext,
  ViewableApplicationResource,
} from 'src/app/account/components/app-resources-view/app-resources-view.component'
import { ResourcesTab } from 'src/app/account/components/application/resources-tab'
import { buildParentChildScenarioResources, buildStatusResources } from '../../mocks/showcase-resources-mocks'

/** Resource-table states: every status pill, plus the parent–child group scenarios. */
@Component({
  selector: 'showcase-resources',
  templateUrl: './showcase-resources.component.html',
  styleUrls: ['./showcase-resources.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseResourcesComponent {
  readonly statusResources: ViewableApplicationResource[] = buildStatusResources()
  readonly parentChildResources: ViewableApplicationResource[] = buildParentChildScenarioResources()
  readonly RecoveryTab = ResourcesTab.RECOVERY_ENVIRONMENT
  readonly BackupTab = ResourcesTab.BACKUP
  readonly StatusContext = StatusContext
}
